module.exports = __webpack_public_path__ + "img/member_ic5_asset.52b65cff.png";